export const getTimestampWithTimeZone = (date: string | undefined): number => {
	if (!date) return -1;
	return new Date(date.includes("Z") ? date : date + "Z").getTime();
};
